import React from "react";
import { connect } from "react-redux";
import { AppState, store } from "../../../redux";
import { setAuthState } from "../../../redux/actions";
import { AUTHENTICATION_MODAL_ID, AUTH_SIGNUP } from "../../../redux/authentication/constants";
import ReactHlsPlayer from "react-hls-player";
import Hls from "hls.js";
// 600px copy of content.radivision.com/images/00/11/de_1241225.jpg: it is the mobile LCP
// element, so it is served from our own origin (no extra connection) and
// scripts/optimize-initial-load.js inlines it into the prerendered HTML.
import heroPoster from "../../../../static/home-hero-poster.webp";

// The stream has a single 3.9 Mbps rendition in 12 s segments (~5.5 MB each). hls.js 0.14
// buffers max(maxBufferLength, 8 * maxBufferSize / bitrate) ahead; with the 60 MB default that
// is ~2 minutes (~65 MB) as soon as the page boots. 10 MB caps it at ~20 s, two segments.
const HLS_CONFIG = { enableWorker: true, maxBufferLength: 20, maxBufferSize: 10 * 1000 * 1000 };
const HERO_VIDEO_SRC = "https://content.radivision.com/streaming/qh/v8/QHv8NeJdQpHxCxuaHQKjfg.m3u8";

export const Component = () => {
  const playerRef = React.useRef<HTMLVideoElement>(null);

  // The prerendered HTML ships this <video> without src/autoplay (see
  // scripts/optimize-initial-load.js), so the browser does not start a second copy of the
  // stream next to hls.js. Where hls.js cannot run (no MediaSource), play the stream natively.
  React.useEffect(() => {
    const video = playerRef.current;
    if (Hls.isSupported() || !video || video.getAttribute("src")) {
      return;
    }
    video.muted = true;
    video.src = HERO_VIDEO_SRC;
    video.play().catch(() => undefined);
  }, []);

  // React.useEffect(() => {
  //   function fireOnVideoStart() {
  //     // Do some stuff when the video starts/resumes playing
  //   }

  //   playerRef?.current?.addEventListener("play", fireOnVideoStart);

  //   return playerRef.current.removeEventListener("play", fireOnVideoStart);
  // }, []);

  // React.useEffect(() => {
  //   function fireOnVideoEnd() {
  //     // Do some stuff when the video ends
  //   }

  //   playerRef.current.addEventListener("ended", fireOnVideoEnd);

  //   return playerRef.current.removeEventListener("ended", fireOnVideoEnd);
  // }, []);

  return (
    <header className="header-container">
      <div className="header-content">
        {/* A <div>, not a <p>: a <p> inside a <p> is invalid HTML, so the prerendered page
            parsed into a different layout than React renders and the hero jumped when the
            app started. */}
        <div className="header-subtitle">
          <p className="header-subtitle">
            Learn, participate and prosper <br />
            in the Private &amp; IPO Markets Movement <br />
            ... and grow wealth like a billionaire.
          </p>
        </div>
        <div className="getting-started-header" style={{ zIndex: 1 }}>
          <div className="gs-btn">
            <button
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target={`#${AUTHENTICATION_MODAL_ID}`}
              onClick={() => {
                store.dispatch(setAuthState({ step: AUTH_SIGNUP }));
              }}
            >
              Join for free
            </button>
          </div>
        </div>
        <p className="header-tagline">Watch. Learn. Connect. Invest.</p>

        <div className="video-section">
          <div className="header-video">
            <ReactHlsPlayer
              playerRef={playerRef}
              src={HERO_VIDEO_SRC}
              // react-hls-player turns the worker off by default, which puts converting each
              // 5 MB segment on the main thread (100-300 ms long tasks while the page boots).
              hlsConfig={HLS_CONFIG}
              autoPlay={true}
              controls={true}
              width="100%"
              height="100%"
              muted={true}
              poster={heroPoster}
            />
          </div>
        </div>
        <p className="video-tagline">
          Radivision’s Founder on why the startup world is uniquely important for wealth creation, and how everyone now
          can have access.
        </p>
      </div>
      <div className="header-background" />
    </header>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const Header = connect(mapState, mapDispatch)(Component);
